module.exports = __webpack_public_path__ + "static/media/id-card-animate.2fc23bc5.svg";